import environments from './environments';

class ConfigManager {
    constructor() {
        // Default to 'local' if not set
        this.currentEnv = 'local';
    }

    setEnvironment(env) {
        if (!environments[env]) {
            throw new Error(`Invalid environment: ${env}. Valid options are: ${Object.keys(environments).join(', ')}`);
        }
        this.currentEnv = env;
        console.log(`Environment set to: ${env}`);
    }

    getCurrentEnvironment() {
        return this.currentEnv;
    }

    getConfig() {
        return environments[this.currentEnv];
    }

    // Specific getters for AWS configuration
    getAWSConfig() {
        const config = environments[this.currentEnv];
        return {
            region: config.AWS_REGION,
            credentials: {
                accessKeyId: config.AWS_ACCESS_KEY_ID,
                secretAccessKey: config.AWS_SECRET_ACCESS_KEY
            }
        };
    }
}

// Create a singleton instance
const configManager = new ConfigManager();
export default configManager;
